/* ============================================================
   Boost Blenz — Contact page slide-up drawers (bb-contact-quick)
   ------------------------------------------------------------
   Progressive enhancement for the "Quick answers" cards.

   A drawer card is a normal <a href="/policies/…"> tagged with
   [data-ct-drawer-open] + aria-controls="<drawer id>". With JS on,
   the click is intercepted and the matching slide-up opens in place.
   With JS OFF (or before this file runs) the card simply navigates to
   its href — so the information is always reachable.

   Accessibility: role="dialog" aria-modal, focus moves into the panel
   on open and is trapped (Tab / Shift+Tab wrap), Escape and the scrim
   close it, and focus returns to the trigger on close.

   No dependencies. Safe in the Theme Editor (delegated on document,
   so sections re-rendered by the editor keep working).
   ============================================================ */
(function () {
  'use strict';

  var OPEN = 'is-open';
  var LOCK = 'ct-drawer-lock';
  var FOCUSABLE =
    'a[href], button:not([disabled]), textarea, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var activeDrawer = null;
  var lastTrigger = null;
  var closeTimer = null;

  function visibleFocusable(root) {
    return Array.prototype.slice.call(root.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
    });
  }

  function openDrawer(drawer, trigger) {
    if (!drawer || activeDrawer === drawer) return;
    if (activeDrawer) closeDrawer(true); // swap without animating focus back
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }

    activeDrawer = drawer;
    lastTrigger = trigger || null;

    drawer.hidden = false;
    // Force a reflow so the added class animates from the hidden state.
    void drawer.offsetWidth;
    drawer.classList.add(OPEN);
    document.documentElement.classList.add(LOCK);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    var panel = drawer.querySelector('.ct-drawer__panel');
    var f = visibleFocusable(panel);
    (f[0] || panel).focus();

    document.addEventListener('keydown', onKeydown, true);
  }

  function closeDrawer(skipFocusReturn) {
    if (!activeDrawer) return;
    var drawer = activeDrawer;
    var trigger = lastTrigger;

    drawer.classList.remove(OPEN);
    document.documentElement.classList.remove(LOCK);
    document.removeEventListener('keydown', onKeydown, true);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    activeDrawer = null;
    lastTrigger = null;

    // Hide after the transition so it isn't tab-reachable while off-screen.
    closeTimer = setTimeout(function () {
      if (!drawer.classList.contains(OPEN)) drawer.hidden = true;
    }, 360);

    if (!skipFocusReturn && trigger && typeof trigger.focus === 'function') trigger.focus();
  }

  function onKeydown(e) {
    if (!activeDrawer) return;

    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      closeDrawer();
      return;
    }

    if (e.key === 'Tab') {
      var panel = activeDrawer.querySelector('.ct-drawer__panel');
      var f = visibleFocusable(panel);
      if (!f.length) { e.preventDefault(); panel.focus(); return; }
      var first = f[0];
      var last = f[f.length - 1];
      if (!panel.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-ct-drawer-open]');
    if (opener) {
      var id = opener.getAttribute('aria-controls');
      var drawer = id ? document.getElementById(id) : null;
      if (drawer) {
        e.preventDefault(); // no-JS falls back to the href (policy page)
        openDrawer(drawer, opener);
      }
      return;
    }
    if (e.target.closest('[data-ct-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });
})();
